export default {
  title: 'MRR report',
  fields: {
    name: 'Name',
    area: 'Area',
    mrr: 'MRR (netto)',
  },
  buttons: {
    download_report: 'Bericht herunterladen',
  },
  toasts: {
    failed_to_load_data: 'Die Daten konnten nicht geladen werden, bitte aktualisieren Sie die Seite',
  },
};
